import { Tabs } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BitazzaText } from '../../../components'
import { Top100 } from './'

interface Props {
    rank: LeaderBoard[] | []
    user?: usersRequest
    onTop100Handler: () => void
    onMyRankHandler: () => void
    onSearchUserTag: (value: string) => void
    searchResults?: LeaderBoard[] | []
    status: string
}

export const LeaderBoardTabs: React.FC<Props> = ({
    rank,
    user,
    onTop100Handler,
    onMyRankHandler,
    onSearchUserTag,
    searchResults,
    status,
}) => {
    const [selectedTab, setSelectedTab] = useState('top100')
    const { t } = useTranslation()
    const items = [
        {
            label: (
                <BitazzaText
                    textAlign="center"
                    content={t('txt_top100')}
                    format="tab"
                    style={{ width: '110px' }}
                />
            ),
            key: 'top100',
            children: (
                <Top100
                    rank={rank}
                    user={user}
                    status={status}
                    selectedTab={selectedTab}
                    notTop3
                />
            ),
        },
        {
            label: (
                <BitazzaText
                    textAlign="center"
                    content={t('txt_my_ranking')}
                    format="tab"
                    style={{ width: '110px' }}
                />
            ),
            key: 'myRanking',
            children: (
                <Top100
                    selectedTab={selectedTab}
                    rank={rank}
                    user={user}
                    notTop3
                    onSearchUserTag={onSearchUserTag}
                    searchResults={searchResults}
                    status={status}
                />
            ),
        },
    ]

    const tabHandler = (value: string) => {
        setSelectedTab(value)
        if (value === 'top100') {
            onTop100Handler()
        } else {
            onMyRankHandler()
        }
    }
    return (
        <Tabs
            destroyInactiveTabPane
            style={{ position: 'fixed', top: '0px', width: '100%' }}
            items={items}
            tabBarGutter={100}
            centered
            onChange={tabHandler}
            // tabBarStyle={
            //     selectedTab === 'myRanking'
            //         ? {}
            //         : {
            //               position: 'absolute',
            //               top: '0px',
            //               width: '100%',
            //               overflow: 'auto',
            //               height: '40px',
            //           }
            // }
            // className={selectedTab === 'myRanking' ? '' : 'tabs-class'}
        />
    )
}
